<template>
  <div>
    <div v-cloak="!done" class="container">
      <section class="section">
        <h3 class="title is-4">Managing Associations and Certificates</h3>
        <hr>
        <p>
          <h4 class="title is-5">Associations</h4>
        </p>
        <p>The first step in streamlining evidence of insurance requests is to create Associations. To create an Association,
          choose the
          <em>Create Association</em> button from the
          <router-link to="/associations">Associations</router-link> page.
          </br>
          </br>
          <figure class="image">
            <img style="max-width: 900px; min-height: 210px;" src="/static/img/CreateAssociation.jpg">
            <figcaption class="caption">Manage Associations List</figcaption>
          </figure>
        </p>
        </br>
        <p>This will open the Association detail page. On this page you set the Association Name, Pin Number and Status. The
          <em>Pin Number</em> is used to create a unique URL link for the certificate. See the section below on Direct Link Requests
          for more information about links to certificates.
        </p>
        </br>
        <p>
          When the Association
          <em>Status</em> is set to Draft, the certificate will not be linkable, so make sure to set the Status to Active when
          you are ready to enable users to access the certificate. Once you have entered the Association Name and Pin Number,
          you can click the
          <em>Create</em> button to save the association.</p>
        </br>
        <p>Now, along the top of the Association page, you will see several buttons. Click the
          <em>Preview</em> button to generate and download a preview PDF file of the Certificate. Use the
          <em>Link</em> icon button to get a link to the certificate. This is the link you can send to owners, loan processors
          and property managers who need to access and generate certificates. Use the
          <em>Copy to Request</em> button to copy the certificate into a request which you can then customize for a specific
          person, e.g., by customizing the Certificate Holder.
          </br>
          </br>
          <figure class="image">
            <img style="min-height: 175px;" src="/static/img/AssociationDetailsHeader.jpg">
            <figcaption class="caption">Association Header Fields</figcaption>
          </figure>
          </br>
          <p>
            The main section on the Associations page is the Certificate itself. This is a comprehensive form where you can enter details
            about the insurance policies, expiration dates and coverage that the Association carries. Use the Additional
            Remarks addendum to provide extra details. You may want to anticipate common questions that a bank normally has
            and preemptively provide that information. Once you have completed this form, you can set the
            <em>Status</em> to Active and click the
            <em>Link</em> button to get the direct link to the certificate. You can paste the link into your browser and try
            it yourself. When a user requests the Certificate, this form will be generated as a PDF file. Here is an
            <a href="/static/InsuranceCertificate.pdf" target="_blank">example PDF Certificate</a>.
            </br>
            </br>
            <figure class="image">
              <img src="/static/img/CertificateForm.jpg">
              <figcaption class="caption">Association Certificate Form</figcaption>
            </figure>
          </p>
          </br>
          <hr>
          <p>
            <h4 class="title is-5">Direct Link Requests</h4>
          </p>
          <p>
            Now that you have created one of more Associations and their evidence of insurance certificates, users can request copies
            of those certificates via direct links. Direct links take the form of
            <em>https://www.getcoi.com/certificates/&ltyour agency short name>/&ltassociation PIN number></em>. For an example,
            try
            <a href="/certificates/arrowig/11111">https://www.getcoi.com/certificates/arrowig/11111</a>.
          </p>
          </br>
          <p>
            When users navigate to a direct link in a web browser, a small request form will be shown. Users can enter 4 pieces of data
            into this form, which will be populated into the certificate PDF. The
            <em>Property Owner Full Name, Property Address and Loan Number</em> will be populated into the Additional Remarks
            addendum of the certificate and the
            <em>Certificate Holder</em> will be populated into the Certificate Holder field of the certificate. After hitting
            next, users will be prompted to enter their name and email address, after which, their certificate will be generated
            and they can download the PDF file.
          </p>
          </br>
          <figure class="image">
            <img src="/static/img/RequestForm.jpg" style="padding-top: 10px;">
            <figcaption class="caption">Certificate Request Form</figcaption>
          </figure>
          </br>
          <p>
            Certificate requests are recorded by the system and can be viewed, modified and regenerated on the
            <a href="/requests">Requests</a> page.
            </br>
            </br>
            <figure class="image">
              <img src="/static/img/Requests.jpg">
              <figcaption class="caption">Requests List</figcaption>
            </figure>
          </p>
          <hr>
          <p>
            Please click the Contact Us link below if you have any questions or need help.
          </p>
      </section>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Footer from '@/Footer'
  export default {
    name: 'Documentation',
    data: function () {
      return {
        done: false
      }
    },
    created: function () {
      window.document.title = 'Managing Associations and Evidence of Insurance Requests'
    },
    mounted: function () {
      this.done = true
    },
    components: {
      Footer
    }
  }

</script>

<style scoped>
  img {
    border: 1px solid #dbdbdb;
    max-width: 800px;
    display: block;
    /*for the img inside your div */
    margin-left: auto;
    margin-right: auto;
  }

  figcaption {
    margin-top: 7px;
    color: #666;
    font-size: 13px;
    font-style: italic;
    margin-bottom: 21px;
    max-width: 100%;
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/Documentation.vue?8bd2c96e